// card_type on each entry of the mirror's unified membership_cards list.
export const MEMBERSHIP_CARD_TYPE = {
  USAGE: "usage",
  PITCH: "pitch",
} as const;
